module.exports = __webpack_public_path__ + "static/tablet-screen-a717bc9d723c9f0b12c408793d1ba55f.jpg";